export enum StatsTableColumn {
  CCY = "CCY",
  BET = "Bet",
  BET_TAX = "BetTax",
  BET_AFTER_TAX = "BetAfterTax",
  PAYOUT = "Payout",
  PAYOUT_TAX = "PayoutTax",
  PAYOUT_AFTER_TAX = "PayoutAfterTax",
  WIN = "Win",
  WIN_TAX = "WinTax",
  WIN_AFTER_TAX = "WinAfterTax",
  FOR_PAYOUT = "ForPayout",
  FOR_PAYOUT_TAX = "ForPayoutTax",
  FOR_PAYOUT_AFTER_TAX = "ForPayoutAfterTax",
  GGR = "GGR",
  BALANCE = "Balance",
  PERCENTAGE = "Percentage",
  AVERAGE_STAKE = "AverageStake",
  NUMBER_OF_PAY_IN_TICKETS = "NumberOfPayInTickets",
  NUMBER_OF_PAY_OUT_TICKETS = "NumberOfPayOutTickets",
  NUMBER_OF_DELETED_TICKETS = "NumberOfDeletedTickets",
  NUMBER_OF_TICKETS = "NumberOfTickets",
}
